<template>
	<NewTeamMemberRowLayout class="new-team-member-row">
		<template v-slot:email>
			<div class="email">
				{{ member.displayName }}
			</div>
		</template>
		<template v-slot:status>
			<div>
				{{ translate( `memberStatusType_${ member.status }` ) }}
			</div>
		</template>
		<template v-slot:role>
			<div v-if="!member.isCurrentUser">
				<TeamingDropDown
					:options="roleTypeOptions"
					:value="member.role"
					@change="onChange"
				>
					<template v-slot:selected="{ selectedOption, onSelectorClicked }">
						<div @click="onSelectorClicked">{{ selectedOption.value }}</div>
					</template>
					<template v-slot:options="{ option, onOptionClicked }">
						<div @click="onOptionClicked(option, $event)">{{ option.value }}</div>
					</template>
				</TeamingDropDown>
			</div>
			<div v-else>
				{{ $t( `common-enums.TeamRoleType_${ member.role }` ) }}
			</div>
		</template>
		<template v-slot:remove>
			<CloseButton
				class="new-team-member-row__remove-icon"
				:borderless="true"
				:disabled="member.isCurrentUser"
				size="SMALL"
				type="QUATERNARY"
				@click="$emit( `remove`, member )"
			/>
		</template>
	</NewTeamMemberRowLayout>
</template>

<script>
import {
	TeamRoleType
} from "@teaming/common-enums";

import {
	TranslateMixin,
	TeamingDropDown,
	CloseButton
} from "@teaming/common-ui";

import NewTeamMemberRowLayout from "./NewTeamMemberRowLayout.vue";

export default {
	name: "NewTeamMemberRow",
	teamingPackage: "common-team",
	mixins: [ TranslateMixin, ],
	emits: [ "roleChange", "remove", ],
	components: {
		NewTeamMemberRowLayout,
		TeamingDropDown,
		CloseButton,
	},
	props: {
		member: {
			type: Object,
			required: true,
		},
	},
	computed: {
		roleTypeOptions() {
			const { $t, } = this;
			return [
				{
					value: TeamRoleType.MEMBER,
					text: $t( "common-enums.TeamRoleType_MEMBER" ),
				},
				{
					value: TeamRoleType.LEAD,
					text: $t( "common-enums.TeamRoleType_LEAD" ),
				},
			];
		},
	},
	methods: {
		onChange( e ) {
			this.$emit( "roleChange", { ...this.member, role: e.value, } );
		},
	},
};
</script>

<style lang="scss" scoped>
$dividerColor: $color1-100;

.new-team-member-row {
	height: 3rem;
	border-top: 0.0625rem solid $dividerColor;
	border-radius: 0;
}

.new-team-member-row__column-label {
	@include font-and-line-for(0);
	font-weight: 600;
}

.new-team-member-row__remove-icon {
	cursor: pointer;
}

.new-team-member-row .email {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
</style>
